import {useEffect, useId, useState} from "react";
import {ThinCloseIcon} from "../../../components/icons/material-icons";
import {NumberToPersianLetters} from "../../../components/techaran/money";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowSnackbar} from "../../../components/template/snackbar";

export const AdminsPresignupEditPrePaymentPriceModal = (props: {
    active: boolean,
    closeHandler: any,
    name:string,
    id:number,
    onDone:any,
    currentPrice:number,
}) => {
    const [price,setPrice] = useState('');
    const [err,setErr] = useState(false);
    const priceId = useId();
    useEffect(() => {
        const isActive = props.active;
        const c = props.currentPrice;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
            setPrice(c.toString());
            setErr(false);
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    const saveChanges = () =>{
        const id = props.id;
        const _price = price.trim();
        if(_price === ''){
            setErr(true);
            return;
        }
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/presignup/edit-price',
            {
                id:id.toString(),
                price:_price,
            },
            true,
            (d: {
                result: string,
                reason: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                props.closeHandler();
                ShowSnackbar(
                    'ویرایش مبلغ پیش پرداخت انجام شد.',
                    'باشه',
                    5000,
                );
                props.onDone();
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')} style={{top:20}}>
                <div className="web-modal-header">
                    <div><b>ویرایش پیش پرداخت</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="add-student">
                        <label>نام دانش‌آموز:</label>
                        <input type="text" disabled={true}
                               className="form-control"
                               value={props.name}
                        />
                        <div style={{height: 20}}/>
                        <label>کد رهگیری:</label>
                        <input type="text" disabled={true}
                               className="form-control"
                               value={"14050" + props.id.toString()}
                        />
                        <div style={{height: 20}}/>
                        <label htmlFor={priceId}>مبلغ پیش‌پرداخت:</label>
                        <input type="number"
                               className={"form-control" + (err ? ' is-invalid' : '')}
                               min={0}
                               value={price}
                               onChange={e => {
                                   const t = e.currentTarget.value;
                                   setPrice(t);
                                   setErr(false);
                               }}
                        />
                        {
                            price !== '' ?
                                <span style={{
                                    display: 'block',
                                    margin: '5px 0 0 0',
                                    fontWeight: 400,
                                    fontSize:14,
                                    color: '#0a53be'
                                }}>{NumberToPersianLetters(parseInt(price)) + " تومان"}</span> : null
                        }
                        <div className={"invalid-feedback" + (err ? ' d-block' : ' d-none')}>
                            لطفا مبلغ را بصورت صحیح وارد نمایید.
                        </div>
                        <div className="d-flex justify-content-end align-items-center" style={{gap: 5, marginTop: 20}}>
                            <button className="cancel-button" onClick={props.closeHandler}>
                                <b>انصراف</b>
                            </button>
                            <button className="btn-pay" onClick={saveChanges}>
                                <b>ذخیره تغییرات</b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};